import {useTranslation} from 'react-i18next';

import {Box, Grid, Typography} from '@mui/material';

import {orangeColors} from '../../../../../../layouts/theme/designSystem';

interface Props {
  matchMakerNotes?: string;
}

export const MatchmakerNotes = ({matchMakerNotes}: Props) => {
  const {t} = useTranslation();

  return (
    <>
      <Grid container direction={'column'}>
        <Typography variant='h3' mb={1}>
          {t('companyApplicants.applicantsCard.cardDetails.matchMakerNotes')}
        </Typography>
        {matchMakerNotes ? (
          <Box bgcolor={orangeColors[5]} p={2} borderRadius={2} minHeight={'150px'}>
            <Typography dangerouslySetInnerHTML={{__html: matchMakerNotes}} />
          </Box>
        ) : (
          <Typography variant='body1' fontStyle={'italic'}>
            {t('companyApplicants.applicantsCard.cardDetails.emptyState.noMatchmakerNotes')}
          </Typography>
        )}
      </Grid>
    </>
  );
};
